import { render } from "./SeventyThirtysection.vue?vue&type=template&id=5249677c&scoped=true"
import script from "./SeventyThirtysection.vue?vue&type=script&lang=js"
export * from "./SeventyThirtysection.vue?vue&type=script&lang=js"

import "./SeventyThirtysection.vue?vue&type=style&index=0&id=5249677c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5249677c"]])

export default __exports__